<template>
  <div class="resources-feed__search resources-search">
    <form class="resources-search__form" @submit.prevent>
      <input
        type="text"
        v-model="searchTerm"
        placeholder="Search by Keyword..."
        class="resources-search__input resources-search__input--small"
      >
      <date-picker v-model="searchDate" value-type="format" />
      <button
        class="resources-search__button"
        title="Search"
        @click="search()"
        @enter="search()"
      >
        <SearchIcon />
      </button>
    </form>
  </div>
</template>

<script>
import store from '../store/store';
import SearchIcon from './SearchIcon';
import { createHelpers } from 'vuex-map-fields';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapGetters } from 'vuex';
const { mapFields } = createHelpers({
  getterType: 'rf/getField',
  mutationType: 'rf/updateField'
});

export default {
  name: 'Search',
  components: {
    SearchIcon,
    DatePicker
  },
  store: store,
  methods: {
    search () {
      if (this.searchTerm === '' && this.searchDate === null && Object.keys(this.currentTaxonomies).length === 0) {
        store.dispatch('rf/updateShowFeaturedEvents', true);
      } else {
        store.dispatch('rf/updateShowFeaturedEvents', false);
      }

      store.dispatch('rf/resetFeed');
      store.dispatch('rf/returnEvents');
    }
  },
  computed: {
    ...mapFields(['searchTerm', 'searchDate']),
    ...mapGetters({
      currentTaxonomies: 'rf/getCurrentTaxonomies'
    })
  }
};
</script>

<style></style>
